import MasterCrud from "@/components/app/MasterCrud";

export default function Suppliers() {
  return (
    <MasterCrud
      endpoint="/suppliers"
      title="Supplier"
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Nama Supplier", type: "text", required: true },
        { key: "contact", label: "Kontak", type: "text" },
        { key: "address", label: "Alamat", type: "textarea" },
        { key: "notes", label: "Catatan", type: "textarea" },
      ]}
    />
  );
}
